module.exports = __webpack_public_path__ + "static/media/lea_img_04.5d32090a.jpg";